import { ENV } from 'services/environment/environment';

export const useAdminReferrer = () => {
  const isFromAdmin = document.referrer.startsWith(ENV.ADMIN_UI_URL);

  return {
    isFromAdmin,
  };
};
